import {isFastExecute} from './commonUtil';

export class RouteUtil {
  static mInstance = null;
  static number = -1;
  static laskPushTime = 0;

  /**
   * 保存路由栈
   * @type {Array}
   */
  static stack = [];

  /**
   * 返回路由注册的名字所在的页面
   * @param name  根据名字返回
   * @param path  根据路径返回 优先根据路径查询
   */
  static back({name, path}) {
    let index = -1;
    if (path) {
      index = this.stack.findIndex(item => item.ROUTE_PATH === path);
    } else if (name) {
      index = this.stack.findIndex(item => item.ROUTE_NAME === name);
    }
    if (index === -1) {
      this.mInstance.go(-1);
    } else {
      this.mInstance.go(index + 1 - this.stack.length);
    }
  }

  static init(instance) {
    RouteUtil.mInstance = instance;
  }

  static template({...params}) {
    RouteUtil.replace({name: 'template', query: {...params}});
  }

  static main({...params}) {
    RouteUtil.replace({name: 'main', query: {...params}});
  }

  static preview({id, ...query}) {
    RouteUtil.replace({name: 'preview',query: {id, ...query}});
  }

  /**
   * 错误页面
   * @param message      错误信息
   * @param hideBtn      隐藏按钮
   * @param btnParams    按钮参数{title,click}
   */
  static error({message, hideBtn, btnParams}) {
    RouteUtil.push({name: 'error', params: {message, hideBtn, btnParams}});
  }

  static push(...params) {
    if (isFastExecute()) return;
    this.laskPushTime = Date.now();
    let param = params[0];
    if (param.params) {
      param.params.CREATE_TIME = Date.now();
    } else {
      param.params = {CREATE_TIME: Date.now()};
    }
    console.log('跳转', params);
    if (this.mInstance) {
      this.mInstance.push(...params);
    } else if (this.$router) {
      this.$router.push(...params);
    } else {
      console.error('路由实例不存在');
    }
  }

  static replace(...params) {
    console.log('跳转', params);
    if (this.mInstance) {
      this.mInstance.replace(...params);
    } else if (this.$router) {
      this.$router.replace(...params);
    } else {
      console.error('路由实例不存在');
    }
  }
}
